// PaymentSuccess.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAuthHeaders } from '../firebase/authHeaders';
import { useAuth } from '../context/authContext';

const PaymentSuccess = () => {
    const location = useLocation();
    const { userData } = useAuth();

    useEffect(() => {
        const handlePaymentSuccess = async () => {
            console.log('=== PAYMENT SUCCESS PAGE LOADED ===');
            console.log('Location search:', location.search);
            
            const urlParams = new URLSearchParams(location.search);
            const paymentIntent = urlParams.get('payment_intent');
            const paypalSuccess = urlParams.get('paypal_success');
            const paypalOrderId = urlParams.get('token'); // PayPal returns token as order ID

            console.log('Payment Intent:', paymentIntent);
            console.log('PayPal Success:', paypalSuccess);
            console.log('PayPal Order ID:', paypalOrderId);

            // Sale records and their buyer/seller notifications are written
            // server-side (the Stripe webhook, and the PayPal capture below),
            // so nothing is recorded from here any more. This page used to
            // replay a localStorage copy of the first cart item, which
            // duplicated every notification, addressed Shopify ones to a
            // literal 'shopify' recipient id, and silently did nothing at all
            // when the buyer closed the tab before returning.
            if (paymentIntent) {
                console.log('=== STRIPE PAYMENT SUCCESS (recorded by webhook) ===');
            } else if (paypalSuccess && paypalOrderId) {
                // PayPal has no webhook here: capturing is what completes the
                // payment, and the server records the sales in the same call.
                console.log('=== PROCESSING PAYPAL PAYMENT SUCCESS ===');
                try {
                    const response = await fetch(`${process.env.REACT_APP_PAYMENT_API}/capture-paypal-payment`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(await getAuthHeaders())
                        },
                        body: JSON.stringify({ paypalOrderId })
                    });

                    const result = await response.json();
                    console.log('PayPal capture result:', result);

                    if (result.success) {
                        console.log('PayPal payment captured successfully:', result.paymentId);
                    } else {
                        console.error('Failed to capture PayPal payment:', result.error);
                    }
                } catch (error) {
                    console.error('❌ Error processing PayPal payment success:', error);
                }
            } else {
                console.log('❌ No payment success parameters found in URL');
                console.log('Available URL parameters:', Array.from(urlParams.entries()));
            }
        };

        handlePaymentSuccess();
    }, [location, userData]);

    return (
        <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
            <div className="text-center">
                <div className="mb-8">
                    <img 
                        src="/assets/icons/icon-check-circle.svg" 
                        alt="Success" 
                        className="w-20 h-20 mx-auto mb-4"
                    />
                    <h1 className="text-3xl font-bold text-white mb-4">
                        Payment Successful!
                    </h1>
                    <p className="text-gray-400 text-lg">
                        Thank you for your purchase. You will receive a confirmation email shortly.
                    </p>
                </div>
                
                <div className="space-y-4">
                    <a 
                        href="/marketplace/categories" 
                        className="inline-block bg-primary text-white px-8 py-3 rounded-lg hover:bg-opacity-90 transition"
                    >
                        Continue Shopping
                    </a>
                    <br />
                    <a 
                        href="/user-profile" 
                        className="inline-block border border-gray-600 text-gray-300 px-8 py-3 rounded-lg hover:bg-gray-800 transition"
                    >
                        View Orders
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
